import Services from "../services/Services";
import DateHelper from "../helpers/DateHelper";
import Usuario from "./Usuario";

export default class Prazo {
	pk;
	acao;
	titulo;
	descricao;
	dataInicio;
	dataFim;
	diasUteis;
	prioridade;
	responsavel;
	empresa;
	partes;
	anexos;
	quantidadeDias;
	situacao;
	ciente;
	cumprido;
	cumpridoEm;
	desativado;
	finalizado;
	supervisor;
	contagem_tempo_trabalhado;
	ultimo_tempo_trabalhado;

	constructor({
		pk,
		acao,
		titulo,
		descricao,
		dataInicio,
		dataFim,
		diasUteis,
		prioridade,
		responsavel,
		supervisor,
		empresa,
		partes,
		anexos,
		quantidadeDias,
		situacao,
		ciente,
		cumprido,
		cumpridoEm,
		desativado,
		finalizado,
		contagem_tempo_trabalhado,
		ultimo_tempo_trabalhado,
	}) {
		this.pk = pk;
		this.acao = acao;
		this.titulo = titulo;
		this.descricao = descricao;
		this.dataInicio = dataInicio;
		this.dataFim = dataFim;
		this.diasUteis = diasUteis;
		this.prioridade = prioridade;
		this.responsavel = Usuario.fromMap(responsavel);
		this.supervisor = Usuario.fromMap(supervisor);
		this.empresa = empresa;
		this.partes = partes;
		this.anexos = anexos;
		this.quantidadeDias = quantidadeDias;
		this.situacao = situacao;
		this.ciente = ciente;
		this.cumprido = cumprido;
		this.cumpridoEm = cumpridoEm;
		this.desativado = desativado;
		this.finalizado = finalizado;
		this.contagem_tempo_trabalhado = contagem_tempo_trabalhado;
		this.ultimo_tempo_trabalhado = ultimo_tempo_trabalhado;
	}

	static async getPrazo(empresaPk, prazoPk) {
		let prazo = await Services.PrazoService.prazo(empresaPk, prazoPk);

		if (prazo) {
			return Prazo.fromMap(prazo);
		}

		return null;
	}

	static async getPrazosPorEmpresa(empresaPk, params) {
		const prazoResponse = await Services.PrazoService.prazosPorEmpresa(
			empresaPk,
			params
		);

		if (prazoResponse.results) {
			return {
				prazos: Prazo.fromListMap(prazoResponse.results),
				totalPrazos: prazoResponse.count,
				paginaSoma: prazoResponse.pagina_soma,
                totalSoma: prazoResponse.total_soma,
			};
		}

		return [];
	}

	static async criar(prazo, empresaPk) {
		const data = Prazo.toFormData(prazo);

		await Services.PrazoService.criarPrazo(empresaPk, data);
	}

	static async editar(prazo, empresaPk) {
		prazo = new Prazo(prazo);

		const data = Prazo.toFormData(prazo);
		await Services.PrazoService.editarPrazo(empresaPk, prazo.pk, data);
	}

	static async desativar(empresaPk, prazoPk, desativar) {
		await Services.PrazoService.desativacaoPrazo(empresaPk, prazoPk, {desativado: desativar});
	}

	static async finalizar(empresaPk, prazoPk) {
		await Services.PrazoService.finalizarPrazo(empresaPk, prazoPk);
	}

	static async darCiencia(empresaPk, prazoPk) {
		await Services.PrazoService.darCiencia(empresaPk, prazoPk);
	}

	static async darComoCumprido(empresaPk, prazoPk) {
		await Services.PrazoService.darComoCumprido(empresaPk, prazoPk);
	}

	static async reabrir(empresaPk, prazoPk) {
		await Services.PrazoService.reabrir(empresaPk, prazoPk);
	}

	static async getHistorico(empresaPk, prazoPk, params) {
		const historicoResponse = await Services.PrazoService.historico(empresaPk, prazoPk, params);

		if (historicoResponse.results) {
			return {
				historico: historicoResponse.results,
				totalHistorico: historicoResponse.count
			};
		}
		return [];
	}

	static async adicionarComentario(empresaPk, prazoPk, mensagem) {
		return await Services.PrazoService.adicionarComentario(empresaPk, prazoPk, {mensagem});
	}

	static async editarComentario(empresaPk, prazoPk, comentarioPk, mensagem) {
		return await Services.PrazoService.editarComentario(empresaPk, prazoPk, comentarioPk, {mensagem});
	}

	static async excluirComentario(empresaPk, prazoPk, comentarioPk) {
		return await Services.PrazoService.excluirComentario(empresaPk, prazoPk, comentarioPk);
	}

	static async getDataFim(empresaPk, data) {
		let responseData = await Services.PrazoService.getDataFim(empresaPk, data);

		if (responseData) {
			return responseData;
		}

		return null;
	}

	static async enviarAnexos(empresaPk, prazoPk, anexos) {
		const data = anexos
			.filter(anexo => (anexo && anexo.pk))
			.map(anexo => anexo.pk);

		return await Services.PrazoService.enviarAnexos(empresaPk, prazoPk, {anexos: data});
	}

	static async excluirAnexo(empresaPk, prazoPk, anexoPk) {
		return await Services.PrazoService.excluirAnexo(empresaPk, prazoPk, anexoPk);
	}

	static async anexos(empresaPk, prazoPk, params) {
		const anexosResponse = await Services.PrazoService.anexos(empresaPk, prazoPk, params);
		if (anexosResponse.results) {
			return {
				anexos: anexosResponse.results,
				totalAnexos: anexosResponse.count
			};
		}
		return [];
	}

	static async baixarAnexo(fileUrl) {
		return await Services.PrazoService.baixarAnexo(fileUrl);
	}

	static async exportarExcelPrazos(empresaPk, params) {
		return await Services.PrazoService.exportarExcelPrazos(empresaPk, params);
	}

	static async iniciarContagemTempoTrabalhado(empresaPk, prazoPk) {
		return await Services.PrazoService.startContagemTempoTrabalhado(
			empresaPk,
			prazoPk,
		);
	}

	static async pausarContagemTempoTrabalhado(empresaPk, prazoPk, timeworkedPk) {
		return await Services.PrazoService.pauseContagemTempoTrabalhado(
			empresaPk,
			prazoPk,
			timeworkedPk,
		);
	}

	static async duplicarLote(empresaPk, data) {
		return await Services.PrazoService.duplicarLote(empresaPk, data);
	}

	static errorDataInicioInvalida() {
		return {
			fields_errors: [
				{
					field: "dt_inicio",
					errors: [
						{
							message: "Data de inicio inválida.",
							code: "invalid date"
						}
					]
				},
			]
		};
	}

	static errorDataPassada() {
		return {
			fields_errors: [
				{
					field: "dt_fim",
					errors: [
						{
							message: "Não é permitido criar prazos com data final passada. Por favor, ajuste a data de início ou a quantidade de dias.",
							code: "past date"
						}
					]
				},
			]
		};
	}

	static toFormData(prazo) {
		if (!prazo) return prazo;

		prazo = Prazo.toMap(prazo);


		const formData = {};

		Object.keys(prazo).forEach(key => {
			switch (key) {
				case "responsavel":
					// Sempre enviar o campo, null se vazio
					if (prazo[key] && prazo[key].pk) {
						formData[key] = prazo[key].pk;
					} else {
						formData[key] = null;
					}
					break;

				case "supervisor":
					// Sempre enviar o campo, null se vazio
					if (prazo[key] && prazo[key].pk) {
						formData[key] = prazo[key].pk;
					} else {
						formData[key] = null;
					}
					break;

				case "dias_uteis":
					if (prazo[key] != "true" && prazo[key] != "false") return;
					formData[key] = JSON.parse(prazo[key]);
					break;

				case "partes":
					if (!prazo[key] || !prazo[key].length) return;
					formData[key] = prazo[key]
						.filter(parte => parte && parte.nome);
					break;

				case "anexos":
					if (!prazo[key] || !prazo[key].length) return;
					formData[key] = prazo[key]
						.filter(anexo => anexo && anexo.pk)
						.map(anexo => anexo.pk);
					break;

				case "dt_inicio":
					if (!prazo[key]) return;
					formData[key] = DateHelper.convertDate(
						prazo[key],
						"DD/MM/YYYY",
						"YYYY-MM-DD"
					);

					break;

				default:
					if (
						prazo[key] === null ||
						prazo[key] === undefined ||
						prazo[key] === ""
					)
						return;
					formData[key] = prazo[key];
					break;
			}
		});

		return formData;
	}

	static toMap(prazo) {
		prazo = {
			...prazo,
			dt_inicio: prazo.dataInicio,
			dt_fim: prazo.dataFim,
			dias_uteis: prazo.diasUteis,
			qtd_dias: prazo.quantidadeDias,
			cumprido_em: prazo.cumpridoEm
		};

		delete prazo.dataInicio;
		delete prazo.dataFim;
		delete prazo.diasUteis;
		delete prazo.quantidadeDias;
		delete prazo.cumpridoEm;

		return prazo;
	}

	static fromMap(map) {
		if (!map) {
			return map;
		}

		Object.keys(map).forEach(key => {
			if (map[key] === null || map[key] === undefined) {
				delete map[key];
			}
		});

		let dataInicio = DateHelper.toDate(map.dt_inicio);
		let dataFim = DateHelper.toDate(map.dt_fim);

		return new Prazo({
			...map,
			dataInicio,
			dataFim,
			diasUteis: map.dias_uteis,
			quantidadeDias: map.qtd_dias,
			cumpridoEm: map.cumprido_em
		});
	}

	static fromListMap(mapList) {
		return mapList.map(map => {
			return Prazo.fromMap(map);
		});
	}
}

export class Situacao {
	static _tipos = {
		EM_DIA: {
			cor: "#649DF1",
			nome: "Em dia"
		},
		FINALIZADO_ATRASO: {
			cor: "#2ABC6B",
			nome: "Finalizado com atraso"
		},
		FINALIZADO: {
			cor: "#2ABC6B",
			nome: "Finalizado sem atraso"
		},
		EM_ALERTA: {
			cor: "#F69F3C",
			nome: "Em alerta"
		},
		ATRASADO: {
			cor: "#EA5455",
			nome: "Atrasado"
		},
		PERDIDO: {
			cor: "#1E1E1E",
			nome: "Prazo perdido"
		},
		DESATIVADO: {
			cor: "#858585",
			nome: "Desativado"
		}
	};

	static getCor(situacao) {
		if (!situacao) return "";
		situacao = Situacao._tipos[situacao];
		if (!situacao) return "";

		return situacao.cor;
	}

	static getNome(situacao) {
		if (!situacao) return "";
		situacao = Situacao._tipos[situacao];
		if (!situacao) return "";

		return situacao.nome;
	}

	static toList() {
		return Object.keys(Situacao._tipos);
	}

	static toObject() {
		return Situacao._tipos;
	}

	static listForSelect() {
		return Object.keys(Situacao._tipos).map(situacao => {
			return {
				text: Situacao._tipos[situacao].nome,
				value: situacao
			};
		});
	}

	static listForLabels() {
		return Object.keys(Situacao._tipos).map(situacao => {
			return {
				text: Situacao._tipos[situacao].nome,
				color: Situacao._tipos[situacao].cor
			};
		});
	}
}
